<script>
const elTransition =
    '0.3s opacity ease-in-out';
const Transition = {
    'before-enter'(el) {
        if (!el.dataset) {
            el.dataset = {};
        }
        el.style.opacity = 0;
    },

    enter(el) {
        el.style.opacity = 1;
    },

    'after-enter'(el) {
        el.classList.add('active');
        el.style.transition = elTransition;
    },

    'before-leave'(el) {
        el.classList.remove('active');
    },

    leave(el) {
        el.style.opacity = 0;
    },

    'after-leave'(el) {
        el.style.transition = '';
    }
};

export default {
    name: 'PopupTranstion',
    functional: true,
    render(h, { children }) {
        const data = {
            on: Transition
        };
        return h('transition', data, children);
    }
};
</script>
